module.exports = __webpack_public_path__ + "img-dashboard/register/other.83e7b26b.png";